var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tab__sub-header" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "kpi__table-container" }, [
      _c(
        "table",
        { staticClass: "kpi-table" },
        [
          _c(
            "tr",
            { staticClass: "kpi-table__header" },
            [
              _c("th", { attrs: { colspan: "2" } }, [
                _vm._v("Key Performance Indicators")
              ]),
              _vm._v(" "),
              _vm._l(_vm.monthAbbrevs, function(month) {
                return _c("th", [_vm._v(_vm._s(month))])
              }),
              _vm._v(" "),
              _c("th", { attrs: { colspan: "3" } }, [_vm._v("YTD")])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "tr",
            { staticClass: "kpi-table__header" },
            [
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("Description")]),
              _vm._v(" "),
              _vm._l(_vm.monthAbbrevs, function(months) {
                return _c("th", [_vm._v("Actual")])
              }),
              _vm._v(" "),
              _c("th", [_vm._v("BMK")]),
              _vm._v(" "),
              _c("th", [_vm._v("Actual")]),
              _vm._v(" "),
              _c("th", [_vm._v("Variance")])
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.metrics, function(metric, index) {
            return _c(_vm.getComponentName(metric.field), {
              key: "row-high-level-" + index,
              tag: "component",
              attrs: { index: index, metric: metric }
            })
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend" }, [
      _c("span", {
        staticClass: "legend__key kpi-performance-table__month--selected"
      }),
      _vm._v(" = Selected Month")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }